import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-stackoverflow",
  "use": "icon-stackoverflow-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-stackoverflow\"><path d=\"M709.4 622L318 539.4 301.6 618l391.4 82z m102-174L504.4 191.4l-51 61.6 307 256.6z m-62.4 79.4L386.4 358l-33.4 73L715.4 600zM652 64l-64 48 238.6 320.6 64-48z m41 656h-400v79.4h400z m79.4 160H213.4V640h-80v320h719V640h-80z\" p-id=\"5993\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol